import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { Box, Button, Group, Image, Menu, ScrollArea, Stack, Text } from '@mantine/core';
import { useClickOutside, useMediaQuery } from '@mantine/hooks';
import classes from './Header.module.css';
import { useState } from 'react';
import { PopupMenuItem } from './PopupMenuItem';
import { UserInfoCard } from './UserInfoCard';
import { menu } from './menu';
export const InfoButton: React.FC = () => {
  const isMobile = useMediaQuery('(max-width: 62em)');
  const {
    i18n
  } = useLingui();
  const [opened, setOpened] = useState(false);
  const ref = useClickOutside(() => setOpened(false));
  return <Menu shadow="md" width={310} opened={opened} withArrow arrowSize={15} transitionProps={{
    duration: 200,
    transition: 'fade-down'
  }} classNames={{
    dropdown: classes.dropdownHeight,
    item: classes.menuItem,
    itemSection: classes.itemSection
  }} radius={5}>
      <Menu.Target ref={ref}>
        <Button variant="filled" color="#464F59" leftSection={<Stack gap={0} justify="start">
              <Box w={{
          base: 45,
          sm: 75
        }}>
                <Text fz="xs" tt="lowercase" mt={4} truncate="end">
                  @bagholder1
                </Text>
              </Box>
              <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)" ta="left" mt={-4}>
                {i18n._('Level 1')}
              </Text>
            </Stack>} size={isMobile ? 'sm' : 'md'} pos="relative" h={40} miw={{
        base: 142,
        sm: 186
      }} classNames={{
        root: classes.infoButton,
        inner: classes.buttonInner
      }} rightSection={<Group pos="absolute" bottom={-1} right={1} gap={0}>
              <Image src="/assets/avatar_user.png" alt="avatar" w={{
          base: 59,
          sm: 78
        }} h={{
          base: 48,
          sm: 64
        }} />
              <Box mt={{
          base: 10,
          sm: 22
        }} ml={-4} mr={4}>
                <Icons className="icon-pr-line-chevron-down" fontSize={16} fw={600} color="var(--icon-color)" />
              </Box>
            </Group>} onClick={() => setOpened(!opened)} />
      </Menu.Target>

      <Menu.Dropdown bg="var(--navbar-bg-color)" p={10} pos="fixed" top={85}>
        <UserInfoCard />
        <Box h="calc(-600px + 100dvh)" style={{
        overflow: 'hidden'
      }}>
          <ScrollArea h="100%" scrollbars="y" type="never">
            {menu.map(item => <PopupMenuItem key={item.title} {...item} />)}
          </ScrollArea>
        </Box>
      </Menu.Dropdown>
    </Menu>;
};